import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDownSquareDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M18.0001 9.5L12.0002 15.5L6.00024 9.5", stroke: "currentColor", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgChevronDownSquareDefault);
export { ForwardRef as ReactComponent };
